import { Injectable } from '@angular/core';
import { AlertComponent } from './alert/alert.component';
import { MatDialog } from '@angular/material/dialog';

@Injectable({
  providedIn: 'root'
})
export class ErrorService {
  errorDescription: string;

  constructor(private dialog: MatDialog) { }

  errorDisplay(error: any, status: any, coustmoizeddata: any) {
    if (error == 500) {
      this.errorDescription = "Internal Server Error";
    }
    else if (error == 503) {
      this.errorDescription = "Service Unavailable";
    }
    else if (error == 401) {
      this.errorDescription = "UnAuthorized User";
    }
    else if (error == 403) {
      this.errorDescription = "Forbidden";
    }
    else if (error == 422) {
      this.errorDescription = "Please Enter Building fusion code";
    }
    else if (error == 404) {
      this.errorDescription = coustmoizeddata + " Not Found";
    }

    else if (error == 204) {
      this.errorDescription = "NO Content";
    }
    else if (error == 200) {
      this.errorDescription = " Saved SuccessFully.........";
    }
    else if (error == 108) {
      this.errorDescription = "Required Fields Must be Selected or Filled";
    }



    const data = {
      data: this.errorDescription,
      status: status
    }
    this.dialog.open(AlertComponent, {
      // width: '800px',
      position: { right: '10px', top: '55px' },
      data: data
    })
  }
}
